import { useState } from "react";
import { Plus } from "lucide-react";

export default function Accordion({ items, testidPrefix = "accordion" }) {
    const [open, setOpen] = useState(0);
    return (
        <div className="divide-y divide-[rgba(201,162,75,0.1)] border-y hairline">
            {items.map((item, i) => {
                const isOpen = open === i;
                return (
                    <div key={i}>
                        <button
                            onClick={() => setOpen(isOpen ? -1 : i)}
                            aria-expanded={isOpen}
                            data-testid={`${testidPrefix}-item-${i}`}
                            className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                        >
                            <span className={`font-display text-lg md:text-xl transition-colors ${isOpen ? "text-[var(--champagne)]" : "text-[var(--ivory)]/85 group-hover:text-[var(--champagne)]"}`}>
                                {item.q}
                            </span>
                            <span className={`w-8 h-8 shrink-0 border flex items-center justify-center transition-all duration-400 ${isOpen ? "border-[var(--gold)] text-[var(--gold)] rotate-45" : "hairline text-[var(--muted)]"}`}>
                                <Plus size={14} strokeWidth={1.5} />
                            </span>
                        </button>
                        <div className={`grid transition-all duration-500 ease-out ${isOpen ? "[grid-template-rows:1fr] opacity-100" : "[grid-template-rows:0fr] opacity-0"}`}>
                            <div className="overflow-hidden">
                                <p className="pb-7 pr-10 text-sm md:text-base text-muted-luxe leading-relaxed max-w-3xl">
                                    {item.a}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
